import { useEffect, useState } from "react";
import YourFamilyReview from "../../Components/YourFamilyReview";

const YourFamilyReviewPage = () => {
  
  return (
    <>
      <YourFamilyReview />
    </>
  );
};

export default YourFamilyReviewPage;
